import { orgAPI } from "@/api/api";
import type { IntegrationConnection } from "@cohesive/api-client";
import type { MicrosoftTeamsGroupEntity } from "@cohesive/api-entities";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

interface UseMicrosoftTeamsTeamsProps {
  connection: IntegrationConnection;
  options?: Partial<UseQueryOptions<MicrosoftTeamsGroupEntity[], Error>>;
}

export function useMicrosoftTeamsTeams({
  connection,
  options = {},
}: UseMicrosoftTeamsTeamsProps) {
  return useQuery<MicrosoftTeamsGroupEntity[]>({
    queryKey: ["microsoft-teams-teams", connection.id],
    queryFn: async () => {
      const response = await orgAPI.toolbox.execute<
        MicrosoftTeamsGroupEntity[],
        Record<string, unknown>
      >({
        integration_connection_id: connection.id,
        action_name: "microsoft-teams-list-teams",
        action_input: {},
      });
      return response.data;
    },
    enabled: !!connection.integration_id,
    staleTime: 1000 * 60,
    ...options,
  });
}
